// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ph-c";
export var backButton = "_ph-4";
export var backIcon = "_ph-5";
export var chevronShortcut = "_ph-6";
export var container = "_ph-1";
export var editor = "_ph-8";
export var editorWrapper = "_ph-7";
export var prefix = "_ph-2";
export var searchIcon = "_ph-3";
export var suffix = "_ph-9";
export var suffixContent = "_ph-a";
export var suffixText = "_ph-b";
export var wrapper = "_ph-0";